module.exports = __webpack_public_path__ + "media/images/logo-nita-eca4e9e1f52ef0461012c662dd7e07ee.png";